import * as React from 'react';

import { AngularDirective } from '../../../common/react/components/AngularDirective';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';

export const SignedOutTemplate = `<div ng-controller="SignedOutCtrl" ng-include="'signedOut.html'"></div>`;
export const SiteSamlSignedOutTemplate = `<div ng-controller="SignedOutCtrl" ng-include="'siteSamlSignedOut.html'"></div>`;

export interface SignedOutProviderProps extends ReactDirectiveProps {}

export const SignedOutProvider = (props: SignedOutProviderProps): JSX.Element => {
  return(
    <div>
      <AngularDirective
        angularContext={props.angularContext}
        template={SignedOutTemplate}
      />
    </div>
  );
};

export const SiteSamlSignedOutProvider = (props: SignedOutProviderProps): JSX.Element => {
  return(
    <div>
      <AngularDirective
        angularContext={props.angularContext}
        template={SiteSamlSignedOutTemplate}
      />
    </div>
  );
};
